import { z } from "zod";
import { DbCreateInputOmit } from "../helpers";
import { WorkspaceRoleSchema } from "../workspace";

export const ForgeProjectRole = z.enum(["Viewer", "Editor", "Admin"]);

export const ForgeProjectMembership = z.object({
  userId: z.string(),
  forgeProjectId: z.string(),
  workspaceMembershipId: z.string(),
  workspaceRole: WorkspaceRoleSchema,
  role: ForgeProjectRole,
});

export type ForgeProjectRole = z.infer<typeof ForgeProjectRole>;
export type ForgeProjectMembership = z.infer<typeof ForgeProjectMembership>;
export type CreateForgeProjectMembership = DbCreateInputOmit<ForgeProjectMembership>;
